import React from "react";

function DownArrowLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 10.9767L14.1251 6.85165L15.3034 8.02999L10.0001 13.3333L4.69678 8.02999L5.87511 6.85165L10.0001 10.9767Z"
        fill="#0E0E0E"
      />
    </svg>
  );
}

export default DownArrowLogo;
